import { codeFromAST, addDecl } from "./utils";
import cantinflas from "cantinflas";

export default function astElement({
	uiAST,
	alias,
	componentTplFile,
	schemaTplFile,
	storiesTplFile,
	name,
	niceName
}) {
	// UI
	const astImport = addDecl({
		type: "lazyImport",
		ast: uiAST,
		name,
		alias
	});

	const astNamedExport = addDecl({
		type: "namedExport",
		ast: astImport,
		name
	});

	const uiCode = codeFromAST(astNamedExport);

	const componentTpl = cantinflas(componentTplFile, {
		NAME: name
	});

	const schemaTpl = cantinflas(schemaTplFile, {
		DISPLAY_NAME: niceName,
		NAME: name
	});

	const storiesTpl = cantinflas(storiesTplFile, {
		NAME: name
	});

	return {
		uiCode,
		componentTpl,
		schemaTpl,
		storiesTpl
	};
}
